import { Component, inject } from '@angular/core';

import { GlobalSpinnerService } from './global-spinner.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-global-spinner',
    templateUrl: './global-spinner.component.html',
    styleUrls: ['./global-spinner.component.scss'],
    imports: [MatProgressSpinner, MatButton, ComponentsModule, AsyncPipe, TranslatePipe]
})
export class GlobalSpinnerComponent {
    public globalSpinnerService = inject(GlobalSpinnerService);
}
